






import Vue from 'vue';

export default Vue.extend({
  name: 'SimpleLoader',
  props: {
    fullPage: {
      type: Boolean,
    },
  },
});
